import { IHeroSliderSlideProps } from "../components/hero-slider-slide";
import { MIN_SLIDE_DELAY_IN_MILLISECONDS } from "../constants";

export function getEmblaDelays(scrollSnaps: number[], slides: IHeroSliderSlideProps[]): number[] {
    return scrollSnaps.map((_, index) => {
        const delay = slides[index]?.delay;
        if (typeof delay !== "number" || delay < MIN_SLIDE_DELAY_IN_MILLISECONDS) {
            return MIN_SLIDE_DELAY_IN_MILLISECONDS;
        }
        return delay;
    });
}
